import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CardContent,
  Divider,
  Container,
  Box,
  TextField,
  TableContainer,
  Paper,
  Button,
  IconButton,
} from "@mui/material";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
// import { Link, useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";

import { Card } from "react-bootstrap";
import "./Return.css";

const useStyles = makeStyles((theme) => ({
  tableContainer: {
    marginBottom: theme.spacing(2),
  },
  inputField: {
    width: 60,
  },
  iconButton: {
    padding: 4,
  },
}));

const Return = () => {
  const [apiResponse, setApiResponse] = useState([]);
  const classes = useStyles();

  const [isSidebarVisible, setSidebarVisible] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1100) {
        setSidebarVisible(false);
      } else {
        setSidebarVisible(true);
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // const location = useLocation();
  // const apiResponse = location.state?.apiResponse || [];

  const [formData, setFormData] = useState({
    orderId: "",
    quantity: "",
    reason: "",
    message: "",
    image: null,
  });

  const handleInputChange = (event) => {
    if (event.target.type === "file") {
      setFormData({ ...formData, image: event.target.files[0] });
    } else {
      setFormData({ ...formData, [event.target.name]: event.target.value });
    }
  };

  const handleSubmit = () => {
    const formDataObj = new FormData();
    formDataObj.append("order_id", formData.orderId);
    formDataObj.append("quantity", formData.quantity);
    formDataObj.append("reason", formData.reason);
    formDataObj.append("message", formData.message);
    formDataObj.append("image", formData.image);

    axios
      .post("http://api.meddaily/return_order", formDataObj)
      .then((response) => {
        console.log(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const handleQuantityChange = (index, event) => {
    const updatedProducts = [...apiResponse];
    updatedProducts[index].quantity = parseInt(event.target.value);
    setApiResponse(updatedProducts);
  };

  const decreaseQuantity = (index) => {
    const updatedProducts = [...apiResponse];
    if (updatedProducts[index].quantity > 1) {
      updatedProducts[index].quantity--;

      setApiResponse(updatedProducts);
    }
  };

  const increaseQuantity = (index) => {
    const updatedProducts = [...apiResponse];
    updatedProducts[index].quantity++;
    setApiResponse(updatedProducts);
  };

  const getEstimatedReturn = () => {
    if (apiResponse.length > 0) {
      const totalPrice = apiResponse.reduce((total, product) => {
        const productPrice = product.price * (product.return_quantity || 0);
        return total + productPrice;
      }, 0);
      return totalPrice.toFixed(2);
    }
    return "0.00";
  };

  const getDeliveryCharges = () => {
    return 100;
  };

  const getTotalAmount = () => {
    const totalAmount = parseFloat(getEstimatedReturn()) - getDeliveryCharges();
    return totalAmount.toFixed(2);
  };

  const getOrderDetails = async () => {
    try {
      const response = await axios.get(`http://api.meddaily.in/my_order`, {
        headers: {
          token: sessionStorage.getItem("token"),
        },
      });
      if (response.status === 200) {
        setApiResponse(response.data.data);
        console.log(response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getOrderDetails();
  }, []);

  return (
    <div>
      <Grid container spacing={2}>
        {isSidebarVisible && (
          <Grid item xs={12} md={3}>
            <Sidebar />
          </Grid>
        )}
        <Grid item xs={12} md={isSidebarVisible ? 9 : 12}>
          <Navbar />
          <Typography variant="h4" mt={3} mb={3}>Return Order</Typography>
          <Divider />
          {/* <Container> */}
            {/* <Card sx={{ my: 2 }}> */}
              {/* <CardContent> */}
                <TableContainer
                  component={Paper}
                  className={classes.tableContainer}
                >
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Product Name</TableCell>
                        <TableCell>Price</TableCell>
                        <TableCell>Purchase Quantity</TableCell>
                        <TableCell>Return Quantity</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {apiResponse.length > 0 ? (
                        apiResponse.map((product, index) => (
                          <TableRow key={index}>
                            <TableCell>{product.products[0].name}</TableCell>
                            <TableCell>{product.price}</TableCell>
                            <TableCell>
                              {product.products[0].quantity || "NA"}
                            </TableCell>

                            <TableCell>
                              <IconButton
                                className={classes.iconButton}
                                onClick={() => decreaseQuantity(index)}
                              >
                                <RemoveCircleOutlineIcon />
                              </IconButton>
                              <TextField
                                type="number"
                                value={product.return_quantity}
                                onChange={(event) =>
                                  handleQuantityChange(index, event)
                                }
                                className={classes.inputField}
                              />
                              <IconButton
                                className={classes.iconButton}
                                onClick={() => increaseQuantity(index)}
                              >
                                <AddCircleOutlineIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={4} align="center">
                            No products available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                    <div style={{ position: "relative", left: "395px" }}>
                      <Box sx={{ marginTop: "20px", textAlign: "end" }}>
                        <Typography variant="h6" sx={{ marginRight: 2 }}>
                          Estimated Return Value: {getEstimatedReturn()}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          marginBottom: 2,
                        }}
                      >
                        <Typography variant="h6" sx={{ marginRight: 2 }}>
                          Delivery Charges: -{getDeliveryCharges()}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          marginBottom: 2,
                        }}
                      >
                        <Typography variant="h6" sx={{ marginRight: 2 }}>
                          Total: {getTotalAmount()}
                        </Typography>
                      </Box>
                    </div>
                  </Table>
                </TableContainer>
              {/* </CardContent> */}
            {/* </Card> */}
          {/* </Container> */}
          <br />
          <Typography variant="h6">Return Details</Typography>
          <Divider />
          <Container>
            <Box mt={2}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    label="Quantity"
                    variant="outlined"
                    fullWidth
                    type="number"
                    name="quantity"
                    value={formData.quantity}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
            </Box>
            <Box mt={2}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="Reason for Return"
                    variant="outlined"
                    fullWidth
                    name="reason"
                    value={formData.reason}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
            </Box>
            <Box mt={2}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    label="Message"
                    variant="outlined"
                    fullWidth
                    multiline
                    rows={4}
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                  />
                </Grid>
              </Grid>
            </Box>
            <Box mt={2}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <input
                    accept="image/*"
                    id="contained-button-file"
                    multiple
                    type="file"
                    style={{ display: "none" }}
                    onChange={handleInputChange}
                  />
                  <label htmlFor="contained-button-file">
                    <Button variant="outlined" component="span">
                      Upload Image
                    </Button>
                  </label>
                </Grid>
              </Grid>
            </Box>
            <Box mt={2}>
              <Grid container spacing={2}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <button className="continue" onClick={handleSubmit}>
                    Continue
                  </button>
                </Grid>
              </Grid>
            </Box>
          </Container>
        </Grid>
      </Grid>
    </div>
  );
};

export default Return;
